/* unplugin-vue-components disabled */import script from "./megamenu.vue?vue&type=script&lang=js"
export * from "./megamenu.vue?vue&type=script&lang=js"

import "./megamenu.vue?vue&type=style&index=0&id=1892b31e&lang=scss"

const __exports__ = script;

export default __exports__